import Vue from 'vue';
import VueRouter from 'vue-router';

import ColorsTool from '@/views/colors/index.vue';
import innoIcons from '@/views/inno-icons/index';
import modules from '@/modules/index.js';
import views from '@/views/index.js';
import documentModuleIndex from '@/modules/document/index';
import fahrdienst452ModuleIndex from '@/modules/fahrdienst452/index';
import fahrdienstModuleIndex from '@/modules/fahrdienst/index';
import store from '@/store/index';
import routerStore from '@/router/routerStore';
import utils from '@/common/utils';

// TODO: Refactoring:
//       Replace all {module}ById types by filesById
//       Replace all documents the like by files
const acknowledgeModulesByModuleType = {
  Document: {
    storeId: documentModuleIndex.moduleId,
    documentIdParam: 'documentId',
    documentsByIdVar: 'documentsById',
    userStateConfirmedAttr: 'dateconfirmed',
    userStateMandatoryToReadAttr: 'mandatoryDateRead',
  },

  Fahrdienst452: {
    storeId: fahrdienst452ModuleIndex.moduleId,
    documentIdParam: 'documentId',
    documentsByIdVar: 'fahrdienst452FileById',
    userStateConfirmedAttr: 'dateread',
    userStateMandatoryToReadAttr: 'mandatoryDateRead',
  },

  Fahrdienst: {
    storeId: fahrdienstModuleIndex.moduleId,
    documentIdParam: 'documentId',
    documentsByIdVar: 'filesById',
    userStateConfirmedAttr: 'dateread',
    userStateMandatoryToReadAttr: 'mandatoryDateRead',
  },
};

const getModuleConfig = (moduleType, moduleInstance) => {
  let moduleTypeAndInstance = moduleType + (moduleInstance ? `_${moduleInstance}` : '');
  return store.state.configs.moduleConfigsByModuleTypeAndInstance[moduleTypeAndInstance];
};

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};

Vue.use(VueRouter);

const routes = [{ path: `/colors`, name: 'colors', component: ColorsTool }];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'activeListItem',
});

/**
 * Add given routesToAdd (single item or array of routes) to the routes array
 * @param {*} routes
 * @param {*} routesToAdd
 */
function addRoutes(routes, routesToAdd, existingRoutes) {
  if (Array.isArray(routesToAdd)) {
    routesToAdd.forEach((route) => {
      if (!existingRoutes[route.name]) {
        routes.push(route);
      }
    });
  } else {
    if (!existingRoutes[routesToAdd.name]) {
      routes.push(routesToAdd);
    }
  }
}

/**
 * Router "beforeEach" router change hook
 */
router.beforeEach(async (to, from, next) => {
  // cancel navigation when from and to paths are the same. Causes an "avoid duplicate navigation" exception
  if (to.fullPath === from.fullPath) {
    console.log('Cancel navigation because from and to are the same and would result in a "avoid duplicate navigation" exception.', to.fullPath);
    return next();
  }

  // define slide navigation direction based on depth of to/from paths
  let toSegmentCount = to.path.split('/').filter((s) => s !== '');
  let fromSegmentCount = from.path.split('/').filter((s) => s !== '');
  if (to.query.noTransition !== undefined) {
    console.log('next navigation without transition');
    routerStore.transitionName = '';
  } else {
    routerStore.transitionName = toSegmentCount >= fromSegmentCount ? 'slide' : 'slide_out';
    console.log(`routerStore.transitionName=${routerStore.transitionName}`);
  }

  // Call beforeNavigationFrom hook in module index.js if the hook exists. Checked and used in both from and to module
  // Delegate to modules routes "beforeNavigationTo" Interceptor (if defined. See in weblinks/routes)
  let moduleConfig = getModuleConfig(to.meta.moduleType, to.params.instance);

  let { moduleType, moduleId } = to.meta;
  console.log(`moduleType=${moduleType}, moduleId=${moduleId}`);
  console.debug(`moduleConfig`, moduleConfig);
  // if the module route defines a moduleRouteHandler this is called before navigation happens
  if (moduleConfig && moduleType && moduleId) {
    let moduleRouteHandler = modules.getModuleHandler(moduleType);
    console.log(`moduleRouteHandler for module ${moduleType} found?${!!moduleRouteHandler}}`);
    if (moduleRouteHandler && moduleRouteHandler.beforeNavigationTo) {
      let { shouldContinue } = await moduleRouteHandler.beforeNavigationTo({
        moduleState: store.state[moduleId],
        moduleConfig,
        from,
        to,
        next,
      });
      console.log(
        `beforeNavigationTo calls the beforeNavigationTo handler of module ${moduleId}. If the return shouldContinue=${shouldContinue} is false, the navigation is interrupted`
      );

      if (!shouldContinue) return;
    }
  }

  moduleConfig = getModuleConfig(from.meta.moduleType, from.params.instance);
  moduleType = from.meta.moduleType;
  moduleId = from.meta.moduleId;

  if (moduleConfig && moduleType && moduleId) {
    let moduleRouteHandler = modules.getModuleHandler(moduleType);
    if (moduleRouteHandler && moduleRouteHandler.beforeNavigationFrom) {
      let { shouldContinue } = moduleRouteHandler.beforeNavigationFrom({
        moduleState: store.state[moduleId],
        moduleConfig,
        from,
        to,
        next,
      });

      if (!shouldContinue) return;
    }
  }

  // Check if we leave a document which should be acknowledged

  let acknowledgeModule = acknowledgeModulesByModuleType[from.meta.moduleType];
  if (acknowledgeModule) {
    // Check if we have a document that needs to be acknowledged

    let moduleStore = store.state[acknowledgeModule.storeId];
    let docsById = moduleStore ? moduleStore[acknowledgeModule.documentsByIdVar] : {};
    let docIdParam = from.params[acknowledgeModule.documentIdParam];
    let docIdParamTo = to.params[acknowledgeModule.documentIdParam];
    let document = docIdParam ? docsById[docIdParam] : null;

    if (docIdParam !== docIdParamTo && document && document.quittierung === 1 && !document._userState.dateconfirmed) {
      // memorize "next" in store to display dialog first and when confirmed proceed by calling next()
      store.commit('setAcknowledgeDocument', { storeModule: acknowledgeModule.storeId, document, next });
    } else {
      // otherwise continue with default operation
      next();
    }
  } else {
    if (to.fullPath === '/' || (to.meta.initiateSyncBeforeNav === true && to.meta.moduleId)) {
      console.log('Route meta param initiateSyncBeforeNav is set=> Initiate module sync for module', to.meta.moduleId);
      store.dispatch('sync/invalidateModuleCacheAndSync', { moduleId: to.meta.moduleId }, { root: true });
    }
    next();
  }
});

/**
 * Configure routes for modules, bottom navigation and all other required features
 * @param {*} configsStore
 */
router.defineRoutes = (configsStore, profileStore) => {
  let { moduleConfigsByModuleType, bottomNavigation = [], homeScreen } = configsStore;

  let routes = [];
  let existingRoutes = {};
  router.getRoutes().forEach((r) => (existingRoutes[r.name] = true));

  let validHomeScreen = getValidHomescreenConfiguration(profileStore, homeScreen);
  let { layout } = validHomeScreen;
  let viewConfig = validHomeScreen;

  let path = '/';
  let viewerRoutes = views.getViewRoutes(path, layout, viewConfig);
  addRoutes(routes, viewerRoutes, existingRoutes);

  if (process.env.NODE_ENV === 'dev') {
    routes.push({
      path: '/inno-icons',
      name: 'inno-icons',
      components: { default: innoIcons },
    });
  }

  // Configure routes by inflating bottomNavigation config
  bottomNavigation.forEach((bottomNavigationItem, index) => {
    //let viewerRoutes = buildViewRoutes(bottomNavigationItem);
    let { path, layout } = bottomNavigationItem;
    const configIdentifier = { idPath: 'bottomNav_' + index };
    let viewerRoutes = views.getViewRoutes(path, layout, bottomNavigationItem, configIdentifier);
    addRoutes(routes, viewerRoutes, existingRoutes);
  });

  // Configure routes for each configured module
  Object.keys(moduleConfigsByModuleType).forEach((moduleType) => {
    if (modules.isModuleImplemented(moduleType)) {
      let moduleRouteHandler = modules.getModuleHandler(moduleType);

      let moduleRoutes;
      if (moduleRouteHandler && moduleRouteHandler.getRoutes) {
        moduleRoutes = moduleRouteHandler.getRoutes({ moduleType, router });
      }

      if (moduleRoutes) addRoutes(routes, moduleRoutes, existingRoutes);
    } else {
      console.warn(`Module "${moduleType}" is not implemented (or not correctly mapped)`);
    }
  });

  let user = JSON.parse(localStorage.getItem('user') || '{}');
  let { userName, groups } = user;
  // Finally register all routes with the router
  routes.forEach((route) => {
    if (!route.isPermitted || route.isPermitted(user, groups)) {
      router.addRoute(route);
    }
  });
  // router.addRoutes(routes);
};

/**
 * Find valid homescreen configuration
 * The visibility of the configuration can be restricted to groups with restrictedToMembersOfGroup property
 * @param {*} profileStore
 * @param {*} homeScreen
 * @returns
 */
function getValidHomescreenConfiguration(profileStore, homeScreen) {
  const groups = profileStore.user.groups;
  let validHomeScreen = homeScreen.find((config) => {
    return utils.isAccessibleByRestrictedToMembersOfGroup(groups, config.restrictedToMembersOfGroup);
  });

  if (!validHomeScreen) {
    validHomeScreen = homeScreen[0]; // Use first configuration if no valid screen found
  }

  return validHomeScreen;
}

export default router;
